import {
  call,
  delay,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { NOTIFICATION_API_URL } from "utils/constants";
import { request } from "utils/request";

import { handleApiError } from "utils/errorHandler";
import { NotificationSetting } from "../type";
import { selectNotificationSettings } from "./selector";
import { actions } from "./slice";

function* fetchNotificationsPreferencesRequest() {
  try {
    yield delay(500);
    const requestURL = `${NOTIFICATION_API_URL}notification/preferences/get`;
    const options = {
      method: "GET",
    };
    const { data, err } = yield call(request, requestURL, options);

    if (err || !data) {
      yield put(actions.setLoading(false));
      handleApiError(err);
      return;
    }
    const notifications = data?.data;

    yield put(actions.setNotifications(notifications));
    yield put(actions.setLoading(false));
  } catch (err: any) {
    yield put(actions.setLoading(false));
    handleApiError(err);
  }
}

function* updateNotificationRequest(
  action: ReturnType<typeof actions.toggleNotification>,
) {
  const { id, field } = action.payload;
  const settings: NotificationSetting[] = yield select(
    selectNotificationSettings,
  );
  const setting = settings.find((s) => s._id === id);

  if (!setting) return;

  try {
    const requestURL = `${NOTIFICATION_API_URL}notification/preferences/update/${setting._id}`;
    const options = {
      method: "PATCH",
      body: JSON.stringify({
        isWebEnabled: setting.isWebEnabled,
        isEmailEnabled: setting.isEmailEnabled,
      }),
    };

    const { data, err } = yield call(request, requestURL, options);

    if (err || !data) {
      yield put(actions.toggleNotification({ id, field }));
      handleApiError(err);
      return;
    }
  } catch (err: any) {
    yield put(actions.toggleNotification({ id, field }));
    handleApiError(err);
  }
}

export default function* notificationSaga() {
  yield takeLatest(
    actions.fetchNotificationsPreferences,
    fetchNotificationsPreferencesRequest,
  );
  yield takeEvery(actions.toggleNotification, updateNotificationRequest);
}
